<template>
  <router-view></router-view>
</template>
<style>
  .black-button {
    background: #000 !important;
    color: #fff !important;
  }
  .black-button:hover {
    background: #fff !important;
    color: #000 !important;
  }
  .white-button {
    background: #fff !important;
    color: #000 !important;
  }
  .white-button:hover {
    background: #000 !important;
    color: #fff !important;
  }
  th .cell {
    font-size: 16px !important;
    color: #000 !important;
    font-weight: 500 !important;
  }
  .pagination.pagination-primary .page-item.active > .page-link {
    background: #000 !important;
    color: #fff !important;
  }
  .boldNumbers {
    font-weight: 700;
  }
  .card-category {
    color: #000 !important;
  }
  .card-collapse .card .card-header a[data-toggle="collapse"] i {
    color: #000 !important;
  }
  #headingOne01 a {
    cursor: pointer;
  }
</style>
